module.exports = __webpack_public_path__ + "d0ab724ae42c0ce3b20bf861049ec4aa.MP3";